const startIndex = 901;
// eslint-disable-next-line import/no-mutable-exports
let baseIndex = startIndex;

export { startIndex, baseIndex };

export function incrementIndex() {
	baseIndex += 2;
	return baseIndex;
}

export function decrementIndex() {
	return baseIndex;
}
